if (!window.customElements.get("tabbed-banner")) {
  class TabbedBanner extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector("swiper-container");
      this.tabNameTemplate = document.getElementById("tabbed-banner-tab-names-template").content.cloneNode(true).textContent;
    }

    connectedCallback() {
      if (!this.slider) return;
      this.getTabNames();
      this.initSlider();
    
    }

    getTabNames() {
      this.tabNames = this.tabNameTemplate.split("||");
    }

    initSlider() {
       
       const tabsNames = this.tabNames;

      Object.assign(this.slider, {
        modules: [],
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            clickable: true,
            bulletActiveClass: 'tabbed-banner__content-slider-bullet-active',
            bulletClass: 'tabbed-banner__content-slider-bullet',
            renderBullet: function (index, className) {
              return '<span class="' + className + '"><span class="tabbed-banner__gold-square"></span>' + tabsNames[index] + "</span>";
            },
          },
          injectStyles: [`
            .tabbed-banner__content-slider-bullet {
              display: inline-flex;
              align-items: center;
              gap: 4px;
              padding: 0;
              margin: 0;
              font-family: var(--typeBaseCondensed);
              font-size: 14px;
              font-weight: 600;
              letter-spacing: 1.96px;
              text-transform: uppercase;
              color: #FFFFFF;
              background: transparent;
              opacity: 0.7;
              cursor: pointer;
              transition: opacity 0.3s ease;

              @media (min-width: 990px) {
                font-size: 16px;
              }
            }
          
            .tabbed-banner__content-slider-bullet:hover {
              opacity: 1;
            }
          
            .tabbed-banner__content-slider-bullet-active {
              opacity: 1;
            }

            .tabbed-banner__gold-square {
              display: inline-block;
              width: 0;
              height: 12px;
              margin-top: 2px;
              background: #D4AF37;
              border-radius: 3.75px;
              opacity: 0;
             
              transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1), 
                          opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1),
                          transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);

              @media (min-width: 990px) {
                      margin-top: 4px;
              }
            }

            .tabbed-banner__content-slider-bullet-active .tabbed-banner__gold-square {
              width: 12px;
              opacity: 1;
            
            }
          `]
          
      });
 
      this.slider.initialize();
    }
  }

  customElements.define("tabbed-banner", TabbedBanner);
}
